function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Seletor Avan\xE7ado");

var SvgAdvancedSelector = function SvgAdvancedSelector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M83.82,21.54H12.18a2,2,0,0,0-2,2V31.1H85.82V23.54A2,2,0,0,0,83.82,21.54ZM48,30.25H11.12V23.66a1.25,1.25,0,0,1,1.26-1.26H46.73A1.26,1.26,0,0,1,48,23.66Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("rect", {
    x: 10.18,
    y: 33.31,
    width: 75.65,
    height: 41.15,
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAdvancedSelector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ADVANCED-SELECTOR.b03a11b6.svg";
export { ForwardRef as ReactComponent };